import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { AppProviders } from '@/providers/AppProviders'
import { AuthProvider } from '@/providers/AuthProvider'
import { AppRouter } from '@/routes/AppRouter'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary title="Application failed to start">
      <AppProviders>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </AppProviders>
    </ErrorBoundary>
  </StrictMode>,
)
